module.exports = __webpack_public_path__ + "img/pickUpPopUp.de870d26.svg";